/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OofBelt { 
    length?: number;
    color?: string;
    thickness?: OofBelt.ThicknessEnum;
    edge?: OofBelt.EdgeEnum;
    shape?: OofBelt.ShapeEnum;
    width?: number;
    labelPlate?: string;
    paintedLabel?: string;
    cottonLayer?: number;
    protective?: boolean;
    reflectiveStripe?: boolean;
    minimalLength?: number;
    maximalLength?: number;
    punchingScrewSize?: string;
    punchingSpace?: number;
    quickRelease?: boolean;
    solar?: boolean;
    elasticBeltType?: OofBelt.ElasticBeltTypeEnum;
    growingBeltType?: OofBelt.GrowingBeltTypeEnum;
    labelPlateWithFrequency?: boolean;
    labelPlateWithId?: boolean;
}
export namespace OofBelt {
    export const ThicknessEnum = {
        StSt: 'ST_ST',
        SfSf: 'SF_SF',
        StSf: 'ST_SF',
        SolarBelt: 'SOLAR_BELT',
        StStStSt: 'ST_ST_ST_ST',
        ElasticBand: 'ELASTIC_BAND'
    } as const;
    export type ThicknessEnum = typeof ThicknessEnum[keyof typeof ThicknessEnum];
    export const EdgeEnum = {
        Rounded: 'rounded',
        Smooth: 'smooth'
    } as const;
    export type EdgeEnum = typeof EdgeEnum[keyof typeof EdgeEnum];
    export const ShapeEnum = {
        Oval: 'oval',
        Round: 'round',
        OvalRound: 'oval-round',
        DropShaped: 'drop-shaped'
    } as const;
    export type ShapeEnum = typeof ShapeEnum[keyof typeof ShapeEnum];
    export const ElasticBeltTypeEnum = {
        Type1: 'type 1',
        Type2: 'type 2',
        ElasticMooseCollar: 'elastic moose collar'
    } as const;
    export type ElasticBeltTypeEnum = typeof ElasticBeltTypeEnum[keyof typeof ElasticBeltTypeEnum];
    export const GrowingBeltTypeEnum = {
        G1: 'G-1'
    } as const;
    export type GrowingBeltTypeEnum = typeof GrowingBeltTypeEnum[keyof typeof GrowingBeltTypeEnum];
}


export type ThicknessEnum = typeof OofBelt.ThicknessEnum[keyof typeof OofBelt.ThicknessEnum];
export type EdgeEnum = typeof OofBelt.EdgeEnum[keyof typeof OofBelt.EdgeEnum];
export type ShapeEnum = typeof OofBelt.ShapeEnum[keyof typeof OofBelt.ShapeEnum];
export type ElasticBeltTypeEnum = typeof OofBelt.ElasticBeltTypeEnum[keyof typeof OofBelt.ElasticBeltTypeEnum];
export type GrowingBeltTypeEnum = typeof OofBelt.GrowingBeltTypeEnum[keyof typeof OofBelt.GrowingBeltTypeEnum];
